import random from 'lodash/random'
import { SUPRA_MAINNET_CHAIN_ID } from 'config/constants/chains'

// Array of available nodes to connect to
export const nodes = [process.env.REACT_APP_NODE_1, process.env.REACT_APP_NODE_2, process.env.REACT_APP_NODE_3]

const rpcs = {
  [SUPRA_MAINNET_CHAIN_ID]: process.env.REACT_APP_NODE_1,
  56: 'https://nd-891-303-547.p2pify.com/8bf0ad33fa15a23a6fdf93cd96ffa776',
  137: 'https://rpc-mainnet.matic.network',
  250: 'https://rpc.ftm.tools/',
}

const getNodeUrl = () => {
  const randomIndex = random(0, nodes.length - 1)
  return nodes[randomIndex]
}

export const getNodeUrlFromChain = (chainId: string) => {
  return rpcs[chainId]
}

export default getNodeUrl
